import { isClient } from './isClient';

function trackFacebookEvent(name) {
  if (isClient() && window.fbq && name) {
    window.fbq('track', name);
  }
}

export default trackFacebookEvent;
